<template>
  <div class="wl-wizard">
    <header class="wl-wizard__header">
      <div class="wl-wizard__steps">
        <span
          v-for="step in steps"
          :key="step"
          class="wl-wizard__step"
          :class="{
            'wl-wizard__step--completed': step < current_step,
            'wl-wizard__step--active': step === current_step
          }"
          >step {{ step }}
          <img
            v-if="step < current_step && stepCompletedIcon"
            :src="stepCompletedIcon"
            :alt="'Step ' + step + ' Icon'"
            :aria-hidden="true"
            loading="lazy"
            class="wl-wizard__step-icon"
          />
        </span>
      </div>
      <slot name="badges"></slot>
    </header>
    <div class="wl-wizard__body">
      <div v-if="hasHeading" class="wl-wizard__heading">
        <img
          class="wl-wizard__heading-icon"
          v-if="headingIcon && hasName"
          :src="headingIcon"
          aria-hidden="true"
          loading="lazy"
        />
        <div class="wl-wizard__name" v-if="hasName">
          {{ name }}
          <span class="wl-wizard__city-state">
            {{ cityState }}
          </span>
        </div>
      </div>
      <div v-if="hasProgressLoader" class="wl-wizard__progress-bar">
        <div class="wl-wizard__progress-bar-container">
          <div class="wl-wizard__progress-bar-text">
            {{ Math.round(currentPercent) }}%
          </div>
          <svg
            class="wl-wizard__progress-bar-svg"
            viewBox="0 0 106 106"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-17.000000, -17.000000)">
                <circle
                  stroke="#E6E8EE"
                  stroke-width="5"
                  fill-rule="nonzero"
                  cx="70"
                  cy="70"
                  r="50"
                ></circle>
                <path
                  d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                  stroke="#40B771"
                  stroke-width="5"
                  :stroke-dasharray="circleProgress"
                  fill-rule="nonzero"
                  transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                ></path>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WlWizard',
  props: {
    steps: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    currentPercent: {
      type: Number,
      default: 0
    },
    firstName: {
      type: String,
      default: null
    },
    headingIcon: {
      type: String,
      default: null
    },
    lastName: {
      type: String,
      default: null
    },
    middleName: {
      type: String,
      default: null
    },
    city: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: null
    },
    stepCompletedIcon: {
      type: String,
      default: null
    },
    // Show/Hide progress loader
    hasProgressLoader: {
      type: Boolean,
      default: true
    },
    // Show/Hide heading used inside the body
    hasHeading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasName: function() {
      return this.firstName && this.lastName;
    },
    circleProgress: function() {
      return (this.currentPercent / 100) * 100 * Math.PI + ',9999';
    },
    name: function() {
      if (this.middleName) {
        return `${this.firstName} ${this.middleName} ${this.lastName}`;
      }

      return `${this.firstName} ${this.lastName}`;
    },
    cityState: function() {
      const city = this.city;
      const state = this.state;

      if (!city && !state) {
        return;
      }

      if (city) {
        return `in ${city}, ${state}`;
      }

      return `in ${state}`;
    }
  },
  data() {
    return {
      current_step: this.currentStep
    };
  }
};
</script>
